import { BluetoothAudioIcon } from './BluetoothAudioIcon';

/**
 * author: Google
 * id 6639774A-9027-4D20-AE57-24C78EF41141
 * name bluetooth-audio
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bluetooth-audio.svg
 * tags
 * - Audio 
 */
export const BluetoothSearchingIcon = BluetoothAudioIcon;
export default BluetoothSearchingIcon